import { create } from 'zustand'

type generalNotificationsState = {
  generalNotifications: any[]
  setGeneralNotifications: (generalNotifications: any[]) => void
  filteredGeneralNotifications: any[]
  setFilteredGeneralNotifications: (filteredGeneralNotifications: any[]) => void
}

export const useGeneralNotificationsStore = create<generalNotificationsState>(
  set => ({
    generalNotifications: [],
    setGeneralNotifications: (generalNotifications: any[]) =>
      set({ generalNotifications }),
    filteredGeneralNotifications: [],
    setFilteredGeneralNotifications: (filteredGeneralNotifications: any[]) =>
      set({ filteredGeneralNotifications }),
  })
)
